import { RpiFilterV2 } from "../../components/search-filter/RpiSearchFilterTypes";
import { GraphQL } from "@rpi/openapi-api";
import { useAuthUser } from "../../hooks/useAuthUser";
import React from "react";
import { useDebouncedValue } from "@mantine/hooks";
import { optArray } from "../../utils/misc.util";

export const useCustomersCommunicationsFilter = () => {
  const user = useAuthUser();

  const [customersSearch, setCustomersSearch] = React.useState("");
  const [debouncedCustomersSearch] = useDebouncedValue(customersSearch, 250);

  const { data, isLoading } = GraphQL.useAdminListCustomersQuery(
    { input: debouncedCustomersSearch },
    { enabled: user.is.SUPER_ADMIN }
  );
  const customers = React.useMemo(() => (data?.adminListCustomers || []).map((customer) => customer.publicId), [data]);

  return React.useMemo(() => {
    return RpiFilterV2.createConfigs<GraphQL.CustomerCommunicationSearchFields>([
      ...optArray<RpiFilterV2.Config<GraphQL.CustomerCommunicationSearchFields>>(user.is.SUPER_ADMIN, [
        {
          type: "text",
          label: "Id",
          field: GraphQL.CustomerCommunicationSearchFields.Id,
        },
        {
          type: "text",
          label: "Email",
          field: GraphQL.CustomerCommunicationSearchFields.Email,
        },

        {
          type: "dropdown",
          label: "Customer",
          field: GraphQL.CustomerCommunicationSearchFields.CustomerPublicId,
          data: customers,
          onSearch: setCustomersSearch,
          isLoading: isLoading,
        },
      ]),
      {
        type: "select",
        label: "Communication type",
        field: GraphQL.CustomerCommunicationSearchFields.Type,
        data: Object.values(GraphQL.CustomerCommunicationType),
      },
      {
        type: "date",
        label: "Created at",
        field: GraphQL.CustomerCommunicationSearchFields.CreatedAt,
      },
    ]);
  }, [user.is, customers, isLoading]);
};
